// src/router/index.js
import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

// 1. 导入需要路由的组件
const Home = () => import('../components/Home/HomePage.vue')
const About = () => import('../components/Home/components/sonContent/about.vue')
const Products = () => import('../components/Home/components/sonContent/ProductCenter.vue')
const NewsList = () => import('../components/Home/components/sonContent/newsResources.vue')
const News = () => import('../components/Home/components/sonContent/newList.vue')
const Case = () => import('../components/Home/components/sonContent/caseConter.vue')
const CaseList = () => import('../components/Home/components/sonContent/caseList.vue')
const Contact = () => import('../components/Home/components/sonContent/aboutUs.vue')
const honorList = () => import('../components/Home/components/sonContent/honorList.vue')
const NotFound = () => import('../components/Home/components/ContentComponents/404.vue')

// 2. 定义路由规则
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '首页',
      description: '加速实现净零碳排，为各行业提供创新智能解决方案',
      keywords: '智能科技产品, 广丰人工智能官网'
    }
  },
  {
    path: '/404',
    name: 'NotFound',
    component: NotFound,
    meta: { title: '页面未找到' }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: { title: '关于我们' }
  },
  {
    path: '/products/:id',
    name: 'Products',
    component: () => import('../components/Home/components/sonContent/ProductCenter.vue'),
    props: true,
    meta: { title: '产品展示' }
  },
  {
    path: '/news/:id',
    name: 'NewsList',
    component: NewsList,
    props: true,

    meta: { title: '新闻详情' }
  },
  {
    path: '/news',
    name: 'News',
    component: News,
    props: true,
    meta: { title: '新闻中心' }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
    meta: { title: '联系我们' }
  },
  {
    path: '/case',
    name: 'Case',
    component: Case,
    meta: { title: '产品案例' }
  },
  {
    path: '/case/:id',
    name: 'CaseList',
    component: CaseList,
    meta: { title: '案例详情' },
    props: true
  },
  {
    path: '/honorList',
    name: 'honorList',
    component: honorList,
    meta: { title: '荣誉奖项' }
  },

]

// 3. 创建路由实例
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

// 4. 全局路由守卫
router.beforeEach((to, from, next) => {
  // 动态设置页面标题（结合 i18n）
  document.title = to.meta.title;

  // 关键：触发预渲染完成事件（与 vue.config.js 中的 renderAfterDocumentEvent 一致）
  if (process.env.NODE_ENV === 'production') {
    document.dispatchEvent(new Event('page-loaded'));
  }

  next();
});

export default router
